import type * as React from 'react';

/**
 * Available sizes for ScoreStickerCard.
 * - Lg: 187px square (default), the prominent headline state
 * - Md: 155px square, level with the product page metric cells
 *
 * Switching size animates between the two.
 */
enum ScoreStickerCardSize {
  Lg = 'lg',
  Md = 'md',
}

interface ScoreStickerCardProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Caption rendered above the score, e.g. "PRODUCT PAGE SCORE". */
  label: string;
  /** The score value to display (0-100). Null renders N/A state. */
  score: number | null;
  /** Score difference (positive = up arrow, negative = down arrow). Hidden when 0 or null. */
  scoreDiff?: number | null;
  /**
   * The size of the card.
   * @default 'lg'
   */
  size?: ScoreStickerCardSize;
  /** Whether the component is in loading state (renders a skeleton). */
  isLoading?: boolean;
  /** Whether the card is muted: drops its tint and border to sit level with the cells while the breakdown is open. */
  isMuted?: boolean;
  /** Whether the component is in disabled state (drops its surface, pale text). */
  isDisabled?: boolean;
  /** Ref forwarded to the root element. */
  ref?: React.Ref<HTMLDivElement>;
}

export { ScoreStickerCardSize };
export type { ScoreStickerCardProps };
